"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
const partners = [{
  name: "Cannabis Cloud",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_cannabis_cloud.png"
}, {
  name: "MilleMaster",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_millemaster.png"
}, {
  name: "Crypto Pay Wallet",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_crypto_pay.png"
}, {
  name: "Quotient Technology",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_quotient.png"
}, {
  name: "Sovereign Infrastructure",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_sovereign_infra.png"
}, {
  name: "Digital Commerce Systems",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_digital_commerce.png"
}, {
  name: "Scalable IP Ventures",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624954/img/logo_scalable_ip.png"
}];
export default function IndustryRecognition() {
  return <section data-section-id="152152" id="strategic-partnerships" className="dark bg-background text-foreground py-10 border-y border-border overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <Carousel opts={{
        align: "start",
        loop: true,
        dragFree: true
      }} className="w-full">
          <CarouselContent className="items-center -ml-4">
            {partners.map((partner, i) => <CarouselItem key={i} data-index={i} className="pl-4 basis-1/2 sm:basis-1/3 md:basis-1/4 lg:basis-1/5 xl:basis-1/6">
                <div className="flex items-center justify-center p-4">
                  <img src={partner.logo} alt={`${partner.name} logo`} className="h-8 md:h-10 w-auto object-contain opacity-50 grayscale transition-all duration-300 hover:opacity-100 hover:grayscale-0 cursor-pointer" />
                </div>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>
      </div>
    </section>;
}